import {
  CbsLogoSvgComponent,
  ActivityLogComponent,
  HistoryLogComponent,
  CbsLogoSvgHorizontalComponent,
  TickCrossComponent,
  DoctypeComponent,
  LoadingIndicatorComponent,
  UserDropdownComponent,
  FormFieldComponent,
  FieldReadonlyComponent,
  SearchInputComponent,
  ResponsePopupComponent,
  SidebarNavComponent,
  BreadcrumbComponent,
  HeadingBlockComponent,
  CustomFormModalComponent,
  ImageComponent,
  CardComponent,
  IconVerticalNavComponent,
  ListSelectComponent,
  ConfirmPopupComponent,
  LoanInstallmentsTableComponent,
  PayeeReadOnlyComponent,
  PayeeFormModalComponent,
  PayeesBlockComponent,
  PayeeBlockComponent,
  EntryFeesBlockComponent,
  IconComponent,
  CbsMultiselectComponent
} from './components/index';

import {
  HumanizeSizePipe,
  OrderByPipe,
  NameTruncatePipe,
  ValidateDatePipe,
  FilterPipe,
  SortPipe,
  FilterReportsPipe,
  DateFormatPipe,
  TimeFormatPipe,
  NumberFormatPipe
} from './pipes';

import {
  FormFocusDirective,
  MacAgentClassDirective,
  MatchHeightDirective
} from './directives';


export const COMPONENTS = [
  // Components
  CbsLogoSvgComponent,
  ActivityLogComponent,
  HistoryLogComponent,
  CbsLogoSvgHorizontalComponent,
  TickCrossComponent,
  DoctypeComponent,
  LoadingIndicatorComponent,
  UserDropdownComponent,
  FormFieldComponent,
  FieldReadonlyComponent,
  SearchInputComponent,
  ResponsePopupComponent,
  SidebarNavComponent,
  BreadcrumbComponent,
  HeadingBlockComponent,
  CustomFormModalComponent,
  ImageComponent,
  CardComponent,
  IconVerticalNavComponent,
  ListSelectComponent,
  ConfirmPopupComponent,
  LoanInstallmentsTableComponent,
  PayeeReadOnlyComponent,
  PayeesBlockComponent,
  PayeeFormModalComponent,
  PayeeBlockComponent,
  EntryFeesBlockComponent,
  IconComponent,
  CbsMultiselectComponent,
  // Pipes
  HumanizeSizePipe,
  OrderByPipe,
  NameTruncatePipe,
  SortPipe,
  ValidateDatePipe,
  FilterPipe,
  FilterReportsPipe,
  DateFormatPipe,
  TimeFormatPipe,
  NumberFormatPipe,
  // Directives
  FormFocusDirective,
  MacAgentClassDirective,
  MatchHeightDirective
];
